module.exports = __webpack_public_path__ + "img/x1-one.a9df9fb6.png";